<div class="label">{{ label() }}</div>
<div class="value"><ng-content></ng-content></div>
